riot.tag2('raq-dealer-info', '<div class="raq-dealer-info-wrapper"> <button id="isPreferredInput" type="checkbox" class="raq-dealer-info-cta checkbox prefered-dealer-btn {\'is-preferred\' : isPreferred}" aria-role="button" aria-label="{labels.dealer.preferred}" checked="{isPreferred}" onclick="{flipPreferred}" show="{opts.dealer}" value="isPreferred" data-tracking="{trakingHandler.preferredDealer(isPreferred, userData)}"> <i class="dl-icon-preferred-dealer"></i> </button> <div class="raq-dealer-info {(parent.showChangeDealer && userData.allowchangedealer) ? \'\' : \'raq-dealer-info-small\'}" show="{opts.dealer}"> <h3 class="raq-dealer-info-name acr-caption-5">{opts.dealer.name}</h3> <div class="raq-dealer-info-detail-wrapper acr-paragraph-4"> <div class="raq-dealer-info-detail address"> <a href="//bing.com/maps/default.aspx?rtp=~adr.{dealerDirectionsParam}" target="_blank" data-tracking="{trakingHandler.dealerDirection(opts.dealer)} "> <i class="dealer-address-icon dl-icon-address"></i> <span>{opts.dealer.address}<br> {opts.dealer.city}, {opts.dealer.state} {opts.dealer.zip}</span> </a> </div> <span class="raq-dealer-info-detail phone"> <a href="tel:{formatPhone(opts.dealer.phone)}" data-tracking="{trakingHandler.dealerPhone(opts.dealer)} "> <i class="dealer-phone-icon dl-icon-phone"></i> <span>{formatPhone(opts.dealer.phone)}</span> </a> </span> </div> <div class="raq-dealer-info-ctas"> <a href="#" class="raq-dealer-info-cta acr-cta-text change-dealer" onclick="{changeDealer}" data-tracking="{trakingHandler.dealerSelection(labels.dealer.changeDealer)} " show="{parent.showChangeDealer && userData.allowchangedealer}">{labels.dealer.changeDealer} </a> </div> </div> <div class="raq-dealer-info" show="{!opts.dealer}"> <button class="raq-dealer-info-cta cta select-dealer" type="button" onclick="{selectDealer}" data-tracking="{trakingHandler.dealerSelection(labels.dealer.selectaDealer)} "> {labels.dealer.selectaDealer} </button> </div> </div> <div class="raq-dealer-info-dealer-cta"> <a href="#" class="raq-dealer-info-cta acr-cta-text change-dealer" onclick="{changeDealer}" data-tracking="{trakingHandler.dealerSelection(labels.dealer.changeDealer)} " show="{parent.showChangeDealer && userData.allowchangedealer}">{labels.dealer.changeDealer} </a> </div>', '', 'dealer-id="{opts.dealer.dealerId}" preferred="{isPreferred}"', function(opts) {

  const CONSTANTS = require('../../core/platform/constants.js').default;
  const params = require('../../core/params');

  this.mixin('bus');
  this.mixin('cookie');

  // Here goes the logic for raq-dealer-info component
  const self = this;

  self.isPreferred = false;

  self.cookiePreferred = self.cookie.get(CONSTANTS.preferredDealerIdCookieName);

  self.trakingHandler = require('../../core/trackingManager');

  self.dealerDirectionsParam = '';

  self.checkPreferred = function checkPreferredCookie() {
    self.cookiePreferred = self.cookie.get(CONSTANTS.preferredDealerIdCookieName);
    if (self.cookiePreferred && self.opts.dealer) {
      if (self.cookiePreferred === self.opts.dealer.dealerId) {
        self.isPreferred = true;
      } else {
        self.isPreferred = false;
      }
    } else {
      self.isPreferred = false;
    }
    self.bus.trigger(self.bus.EVENTS.DEALERS.PREFERRED_CHECKED, self.isPreferred);
  };

  self.getDealerDirectionsParam = function getDlrDirsParam() {
    let dlrDirsParamStr = '';
    if (self.opts.dealer) {
      const dlr = self.opts.dealer;
      dlrDirsParamStr = `${dlr.address}, ${dlr.city}, ${dlr.state} ${dlr.zip}`;
    }
    return escape(dlrDirsParamStr);
  };

  self.flipPreferred = function togglePreferred() {
    if (!self.isPreferred) {
      self.isPreferred = true;
      self.bus.trigger(self.bus.EVENTS.DEALERS.SET_PREFERRED,
        {
          dealerId: self.opts.dealer.dealerId,
          dealerName: self.opts.dealer.name,
        });
    } else {
      self.isPreferred = false;
      self.bus.trigger(self.bus.EVENTS.DEALERS.UNSET_PREFERRED);
    }
  };

  self.changeDealer = function changeDealer() {
    self.bus.trigger(self.bus.EVENTS.DEALERS.CHANGE);
    if (self.userData) {
      self.bus.trigger(self.bus.EVENTS.STEPS.DEALER_UPDATED,
        { origin: 'dealer', unselect: true });
    }
  };

  self.selectDealer = function selectDealer() {
    self.bus.trigger(self.bus.EVENTS.DEALERS.CHANGE);
  };

  self.formatPhone = function formatPhone(number) {
    const numbers = number.replace(/\D/g, '');
    const char = { 0: '', 3: '-', 6: '-' };
    let i;
    let formated;
    formated = '';
    for (i = 0; i < numbers.length; i++) {
      formated += (char[i] || '') + numbers[i];
    }
    return formated;
  };

  self.on('update', () => {
    self.userData = params.userData();
    self.checkPreferred();
    self.dealerDirectionsParam = self.getDealerDirectionsParam();
  });

  self.bus.on(self.bus.EVENTS.DEALERS.DEALER_FETCHED, self.update);
  self.bus.on(self.bus.EVENTS.DEALERS.CHANGED, self.update);
  self.bus.on(self.bus.EVENTS.CONTAINER.MOUNTED, self.update);
  self.bus.on(self.bus.EVENTS.DEALERS.CHECK_PREFERRED, self.checkPreferred);
});
